import { BO_V2_QUESTIONNAIRE_FIELD_SCHEMA } from '@gcv/shared';

export const BeneficialOwnersRequirementIds = [
  BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_1.id,
  BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_2.id,
  BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_3.id
];
